/* ========================================================================
   Data Layer (GTM)
 ========================================================================== */

app.dataLayer = (function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  const init = function () {
    initGtmElements();
    intTelElements();
    initMailtoElements();
    initSearchKeywords();
  };

  const initGtmElements = function () {
    const gtmElements = document.querySelectorAll('[data-gtm-event]');

    gtmElements.forEach((element) => {
      if (element.dataset.gtmInit) return;
      if (element.dataset.gtmIgnore) return;

      element.addEventListener('click', (event) => {
        let eventName = element.dataset.gtmEvent ? element.dataset.gtmEvent : '';

        if (eventName === '') return;
        let args = {};

        args['pageUrl'] = window.location.pathname;
        args['destinationUrl'] = element.getAttribute('href');

        if (element.dataset.pagePart) {
          args['pagePart'] = element.dataset.pagePart;
        }

        pushEvent(eventName, args);
      });

      element.dataset.gtmInit = true;
    });
  };

  const intTelElements = function () {
    const telElements = document.querySelectorAll('[href^="tel:"]');

    telElements.forEach((element) => {
      // Check if element already has a custom event
      if (typeof element.dataset.gtmEvent !== 'undefined') return;

      element.addEventListener('click', (event) => {
        let args = {};

        args['pageUrl'] = window.location.pathname;
        args['contact'] = element.getAttribute('href');

        if (element.dataset.pagePart) {
          args['pagePart'] = element.dataset.pagePart;
        }

        pushEvent('phoneNumberClick', args);
      });
    });
  };

  const initMailtoElements = function () {
    const mailtoElements = document.querySelectorAll('[href^="mailto:"], [data-email]');

    mailtoElements.forEach((element) => {
      // Check if element already has a custom event
      if (typeof element.dataset.gtmEvent !== 'undefined') return;

      element.addEventListener('click', (event) => {
        let args = {};
        let email = '';

        if (typeof element.dataset.email !== 'undefined') {
          email = 'mailto:' + atob(element.getAttribute('data-email'));
        } else {
          email = element.getAttribute('href');
        }

        args['pageUrl'] = window.location.pathname;
        args['contact'] = email;

        if (element.dataset.pagePart) {
          args['pagePart'] = element.dataset.pagePart;
        }

        pushEvent('emailClick', args);
      });
    });
  };

  const initSearchKeywords = function () {
    const searchResults = document.querySelector('[data-search-keywords]');
    if (searchResults) {
      pushEvent('search', {
        keywords: searchResults.dataset.searchKeywords,
      });
    }
  };

  const pushEvent = function (eventName, args) {
    if (eventName === '') return;

    args = args || {};

    let gtmEvent = { event: eventName };

    for (const key in args) {
      if (args.hasOwnProperty(key)) {
        gtmEvent[key] = args[key];
      }
    }

    // DATALAYER
    window.dataLayer.push(gtmEvent);

    if (util.debugMode) console.log(gtmEvent);
  };

  // Expose public functions and variables
  return {
    init: init,
    initGtmElements: initGtmElements,
    pushEvent: pushEvent,
  };
})();
